import { HTML5toTouch } from "rdndmb-html5-to-touch";
import { useEffect, useState } from "react";
import { DndProvider } from "react-dnd-multi-backend";
import "../App.css";
import { DraggableMessage } from "../components/Draggables";
import {
  BINARY_FONT,
  BINARY_SYSTEM,
  COLOR_DARK,
  FONT,
  REGEX_VALID_BINARY
} from "../defaults";
import coin_1 from "../images/coin_1.png";
import coin_2 from "../images/coin_2.png";
import coin_4 from "../images/coin_4.png";
import coin_8 from "../images/coin_8.png";
import {
  buttonCheck,
  level4BinaryTask,
  level4BinaryTextBox1,
  level4BinaryTextBox2,
  level4BinaryTextBox3,
  level4BinaryTextBoxChoose,
  level4BinaryTextBoxLeft,
  level4BinaryTextBoxNotice,
  level4BinaryTextBoxOne,
  level4BinaryTextBoxProperty,
  level4BinaryTextBoxRight,
  level4BinaryTextBoxZero,
  levelCorrect,
  levelIncorrect,
  levelNoInputMulti
} from "../strings";

const LevelNumber = 4;

const inputStyle = {
  fontFamily: BINARY_FONT,
  width: "4dvh",
  margin: "0 auto",
  paddingLeft: "0.5dvh",
  paddingRight: "0.5dvh"
};

const headerStyle = {
  marginTop: "4dvh",
  padding: "0 3dvh",
  fontFamily: FONT,
  fontSize: "4dvh",
  textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
};

const gridStyle = {
  display: "grid",
  width: "70dvh",
  height: "30dvh",
  gridTemplateColumns: "repeat(10, 1fr)",
  gridTemplateRows: "repeat(4, 1fr)",
  border: "0.4dvh solid black",
  borderRadius: "0.25em",
  boxShadow: "0.6svh 0.6svh 0.9svh rgba(0, 0, 0, 0.3)",
  backgroundColor: "#75c7db"
};

const gridItemStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderTop: gridStyle.border,
  fontFamily: BINARY_FONT,
  textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.6)",
};

const textBoxStyle = {
  marginTop: "2dvh",
  padding: "3.4dvh", // 2*this.padding + this.width === gridStyle.width + 2*gridStyle.border
  backgroundColor: COLOR_DARK,
  borderRadius: "0.5em",
  width: "64dvh",
  fontFamily: FONT,
  fontSize: "2dvh",
  lineHeight: "3dvh",
  textAlign: "center",
  filter: "drop-shadow(0.2svh 0.2svh 0.6svh rgba(0, 0, 0, 0.5))",
  textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
  border: "0.2dvh solid black"
};

const solutionArray = [ // Array containing solution for right side of grid.
  ["0","0","1","0"], 
  ["0","1","0","0"], 
  ["1","0","1","0"]
];

const leftSideArray = [ // Array containing contents to be rendered on left side of grid. Each element (itself an array) is to be rendered in a new row.
    ["0","0","0","1"], 
    ["0","0","1","0"], 
    ["0","1","0","1"]
];

const coinImages = [coin_8, coin_4, coin_2, coin_1];

function renderGrid(inputArray, setInputArray, _dropdownLeftRight, _setDropdownLeftRight, _dropdownZeroOne, _setDropdownZeroOne, disableInput) {
    
  return (
    <div>
      <div style={gridStyle}>

        {coinImages.map((coin,coinId) => {
          return (<div key={coinId} style={{...gridItemStyle, borderTop: "0dvh", filter: "drop-shadow(0.2svh 0.2svh 0.6svh rgba(0, 0, 0, 0.5))"}}><img style={{maxHeight: "100%", maxWidth: "100%"}} src={coin} alt="coin"/></div>)
        })}
        <div></div>
        <div></div>
        {coinImages.map((coin,coinId) => {
          return (<div key={coinId} style={{...gridItemStyle, borderTop: "0dvh", filter: "drop-shadow(0.2svh 0.2svh 0.6svh rgba(0, 0, 0, 0.5))"}}><img style={{maxHeight: "100%", maxWidth: "100%"}} src={coin} alt="coin"/></div>)
        })}
        
        {leftSideArray[0].map((value, index) => { // First row
          return (<div style={gridItemStyle}><span style={{opacity: index <= 2 ? "0.5" : "1"}}>{value}</span></div>)
        })}
        <div style={{...gridItemStyle, fontFamily: FONT}}>&nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;2</div>
        <div style={{...gridItemStyle, fontFamily: FONT}}>=</div>
        {inputArray[0].map((input, index) => { // Input field corresponds to row 0, column index.
          return (
          <div key={index} style={gridItemStyle}>
            <input 
            className="input-field"
            style={inputStyle}
            type="text"
            inputMode="numeric"
            value={input}
            maxLength={1}
            disabled={disableInput}
            placeholder=""
            pattern={REGEX_VALID_BINARY}
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\s/g, ''); // LLM-generated. Disallow white-space input.
              let newInputArray = [...inputArray];
              newInputArray[0][index] = e.target.value;
              setInputArray(newInputArray);}
            }
            />
          </div>
          )
        })}

        {leftSideArray[1].map((value, index) => { // Second row
          return (<div style={gridItemStyle}><span style={{opacity: index <= 1 ? "0.5" : "1"}}>{value}</span></div>)
        })}
        <div style={{...gridItemStyle, fontFamily: FONT}}>&nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;2</div>
        <div style={{...gridItemStyle, fontFamily: FONT}}>=</div>
        {inputArray[1].map((input, index) => { // Input field corresponds to row 1, column index.
          return (
            <div key={index} style={gridItemStyle}>
                <input 
                className="input-field"
                style={inputStyle}
                type="text"
                inputMode="numeric"
                value={input}
                maxLength={1}
                disabled={disableInput}
                placeholder=""
                pattern={REGEX_VALID_BINARY}
                onChange={(e) => {
                  e.target.value = e.target.value.replace(/\s/g, ''); // LLM-generated. Disallow white-space input.
                  let newInputArray = [...inputArray];
                  newInputArray[1][index] = e.target.value;
                  setInputArray(newInputArray);}
                }
                />
            </div>
            )
        })}

        {leftSideArray[2].map((value, index) => { // Third row
          return (<div style={gridItemStyle}><span style={{opacity: index <= 0 ? "0.5" : "1"}}>{value}</span></div>)
        })}
        <div style={{...gridItemStyle, fontFamily: FONT}}>&nbsp;&nbsp;&nbsp;&nbsp;•&nbsp;2</div>
        <div style={{...gridItemStyle, fontFamily: FONT}}>=</div>
        {inputArray[2].map((input, index) => { // Input field corresponds to row 2, column index.
          return (
            <div key={index} style={gridItemStyle}>
                <input 
                className="input-field"
                style={inputStyle}
                type="text"
                inputMode="numeric"
                value={input}
                maxLength={1}
                disabled={disableInput}
                placeholder=""
                pattern={REGEX_VALID_BINARY}
                onChange={(e) => {
                  e.target.value = e.target.value.replace(/\s/g, ''); // LLM-generated. Disallow white-space input.
                  let newInputArray = [...inputArray];
                  newInputArray[2][index] = e.target.value;
                  setInputArray(newInputArray);}
                }
                />
            </div>
            )
        })}
          
      </div>
    </div>
  )
}

function renderTextBox(dropdownLeftRight, setDropdownLeftRight, dropdownZeroOne, setDropdownZeroOne, disableInput) {

  return (
    <div style={textBoxStyle}>
      <span>{level4BinaryTextBoxNotice}</span>
      <br></br>
      <br></br>
      {level4BinaryTextBox1}
      <div className="select-container">
        <select
        value={dropdownLeftRight}
        disabled={disableInput}
        onChange={(e) => {setDropdownLeftRight(e.target.value)}}
        >
          <option value="">{level4BinaryTextBoxChoose}</option>
          <option value="left">{level4BinaryTextBoxLeft}</option>
          <option value="right">{level4BinaryTextBoxRight}</option>
        </select>
        <div className="select-arrow"/>
      </div>
      
      {level4BinaryTextBox2}<span style={{textDecorationLine: "underline"}}>{level4BinaryTextBoxRight}</span>{level4BinaryTextBox3}
      <div className="select-container">
        <select
        value={dropdownZeroOne}
        disabled={disableInput}
        onChange={(e) => {setDropdownZeroOne(e.target.value)}}
        >
          <option value="">{level4BinaryTextBoxChoose}</option>
          <option value="zero">{level4BinaryTextBoxZero}</option>
          <option value="one">{level4BinaryTextBoxOne}</option>
        </select>
        <div className="select-arrow"/>
      </div>
      &nbsp;.
      <br></br>
      <br></br>
      {level4BinaryTextBoxProperty}
  </div>
  )
}

function Level4Binary({levelProgress, setLevelProgress, showMessage, setShowMessage, disableInput, setDisableInput}) {
  const [inputArray, setInputArray] = useState(Array.from({ length: 3}, () => new Array(4).fill(""))); // 2D-array in which all user input is stored. First dimension is row, second dimension is column.
  const [message, setMessage] = useState("");
  const [dropdownLeftRight, setDropdownLeftRight] = useState("");
  const [dropdownZeroOne, setDropdownZeroOne] = useState("");
  const [correct, setCorrect] = useState(false);
  const [allFilled, setAllFilled] = useState(true); // Boolean flag checking if all input fields have been filled. Used in checkAnswers(). Used to make sure wrong inputs are removed only if all input fields have been filled.

  useEffect(() => {
    const emptyInputArray = Array.from({ length: 3}, () => new Array(4).fill(""));
    setInputArray(emptyInputArray);
  }, [levelProgress]);

  const checkAnswers = () => {
    const isCorrectGrid = solutionArray.every((rowArray, rowIndex) => rowArray.every((value, index) => value === inputArray[rowIndex][index])); // Checking every index of every row.
    const isCorrectTextBox = dropdownLeftRight === "left" && dropdownZeroOne === "zero";
    const isCorrect = isCorrectGrid && isCorrectTextBox;
    setCorrect(isCorrect);
    if (isCorrect) {
      setMessage(levelCorrect); // Unlock next level immediately because there is only one level.
    } else if (dropdownLeftRight === "" || dropdownZeroOne === "" || inputArray.some((rowArray, _) => rowArray.some((value) => value === ""))) { // Case: Not all fields filled.
      setAllFilled(false);
      setMessage(levelNoInputMulti);
    } else {
      setMessage(levelIncorrect);
    }
    displayMessage();
  };

  const displayMessage = () => {
    setShowMessage(true);
    setDisableInput(true);
  };

  const handleCloseMessage = () => {
    if (correct) { // Increase Progress only upon closing popup message.
      let newProgress = [...levelProgress];
      newProgress[LevelNumber] += 3; // +3 instead of +1 because there is only one level.
      setLevelProgress(BINARY_SYSTEM, newProgress)
    }
    if (allFilled) { // Only if all input fields have been filled should the wrong inputs be removed. Do not want to help if exercise hasn't been properly tried.
      let newInputArray = [...inputArray];
      newInputArray.map((rowArray, rowIndex) => rowArray.map((value, index) => { // Set only the wrong inputs to empty strings.
        if (value !== solutionArray[rowIndex][index]) {
          newInputArray[rowIndex][index] = "";
        }
      }))
      setInputArray(newInputArray);
      if (dropdownLeftRight !== "left") setDropdownLeftRight("");
      if (dropdownZeroOne !== "zero") setDropdownZeroOne("");
    }
    setMessage("");
    setAllFilled(true);
    setDisableInput(false);
    setCorrect(false);
  };

  return (
    <div>
      <div style={headerStyle}>
        {level4BinaryTask}
      </div>
      <DndProvider options={HTML5toTouch}>
        {showMessage && <DraggableMessage show={showMessage} setShow={setShowMessage} handleClose={handleCloseMessage} message={message}/>} {/* Conditionally rendering it with showMessage makes the message re-render, and hence center itself, every time. */}
        <div style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: "3dvh"}}>
          {renderGrid(inputArray, setInputArray, dropdownLeftRight, setDropdownLeftRight, dropdownZeroOne, setDropdownZeroOne, disableInput)}
          {renderTextBox(dropdownLeftRight, setDropdownLeftRight, dropdownZeroOne, setDropdownZeroOne, disableInput)}
        </div>
      </DndProvider>
      <button className="checkAnswer-button" onClick={checkAnswers} disabled={disableInput}>
          {buttonCheck}
      </button>
    </div>
  );
}

export default Level4Binary;